import { API_URL } from "./apiBase";

export const getCompanyProfile = async (
  company_id: string,
  accessToken: string | null
) => {
  return fetch(`${API_URL}/company/${company_id}/profile`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  }).then((res) => res.json());
};


// export const patchCompanyProfile = async (
//   company_id: string,
//   body: any,
//   accessToken: string | null
// ) => {
//   return fetch(`${API_URL}/company/${company_id}/profile`, {
//     method: "PATCH",
//     body: JSON.stringify(body),
//     headers: {
//       Authorization: `Bearer ${accessToken}`,
//       'Content-Type': 'application/json',
//     },
//   }).then((res) => res.json());
// };
//
// export const getCompanySettings = async (
//   company_id: string,
//   accessToken: string | null
// ) => {
//   return fetch(`${API_URL}/company/${company_id}`, {
//     method: "GET",
//     headers: {
//       Authorization: `Bearer ${accessToken}`,
//     },
//   }).then((res) => res.json());
// };

export const inviteCompanyUser = async (
  company_id: string,
  body: any,
  accessToken: string | null
) => {
  return fetch(`${API_URL}/company/${company_id}/invite_user`, {
    method: "POST",
    body: JSON.stringify(body),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
  }).then((res) => res.json());
};
